<template>
  <div class="ispdf">
    <div class="title">
      <span>{{ title }}</span>
      <button @click="$emit('gocourse', catId)">返回课程主页</button>
    </div>
    <div class="content">
      <div class="bigbox" ref="all">
        <div class="pdfbox">
          <div class="head">
            <div class="mod">
              <div
                class="left"
                :class="{ select: idx == 2 }"
                @touchstart="idx = 2"
                @touchend="idx = -1"
                @click="changePdfPage(0)"
              >
                <img src="../../assets/course/left.png" alt="" />
              </div>
              <span>{{ currentPage }} /{{ pageCount }}</span>
              <div
                class="right"
                :class="{ select: idx == 3 }"
                @touchstart="idx = 3"
                @touchend="idx = -1"
                @click="changePdfPage(1)"
              >
                <img src="../../assets/course/right1.png" alt="" />
              </div>
            </div>
            <ul>
              <li
                :class="{ select: idx == 1 }"
                @touchstart="idx = 1"
                @touchend="idx = -1"
                @click="scaleX"
              >
                <img src="../../assets/course/small.png" alt="" />
              </li>
              <li
                :class="{ select: idx == 0 }"
                @touchstart="idx = 0"
                @touchend="idx = -1"
                @click="scaleD"
              >
                <img src="../../assets/course/big.png" alt="" />
              </li>
              <li class="btn-fullscreen" @click="screenfull">
                <img src="../../assets/course/src.png" alt="" />
              </li>
            </ul>
          </div>
          <pdf
            class="con"
            :src="resUrl"
            :page="currentPage"
            @progress="loadedRatio = $event"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            @loaded="loadPdfHandler"
            ref="wrapper"
          >
          </pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import entry from "../../units/entryDetry.js";
import pdf from "vue-pdf";
import screenfull from "screenfull";
export default {
  name:'ispdf',
  props: {
    resourceUrl: String,
    title: String,
    catId: [String, Number],
    menuId: [String, Number],
    isFree: [String, Number],
  },
  components: {
    pdf,
  },
  sockets: {
    //查看socket是否渲染成功
   connect() {
      console.log("链接成功");
      if (this.isLogin == 0) {
        // console.log(this.isLogin)
        this.$socket.emit("login", { role: this.role, userId:localStorage.getItem('userId')});
          this.$socket.emit("studyStart", { courseId: this.catId,
          taskId: this.menuId});
      }
    },
    studyStart() {
      console.log("进入任务");
    },
    login(){
      console.log("登录")
    }
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      scale: 100, // 放大系数
      idx: -1,
      clauseTitle: "",
      loadedRatio: 0,
      fullscreen: false,
      resUrl: " ",
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    role(){
      return this.$store.state.role
    },
    userId(){
      return this.$store.state.userId
    }
  },
  watch: {
    resourceUrl: function (val) {
      this.resourceUrl=val
      this.reload();
      this.init()
    },
    isLogin: function (val) {
      //  console.log(val)
    },
     role:function(){

    },
    userId:function(){
      
    }
  },
  created() {
    this.init();
  },

  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));

    window.onresize = () => {
      // 全屏下监控是否按键了ESC
      if (!this.checkFull()) {
        // 退出全屏
        this.fullscreen = false;
      }
    };
  },
  methods: {
    
    init() {
      this.resUrl = entry.Decrypt(
        this.resourceUrl,
        "w2SIy2Hx%2i!tTCd-ikwHEv_kQmB58xI",
        "R7#54X&gLB!6Q&s="
      );
      // console.log("是否为试用：",this.isFree)
      if (this.isFree == 1) {
        // console.log("试用")
      } else {
        this.$socket.emit("studyStart", {
          courseId: this.catId,
          taskId: this.menuId,
        });
      }
    },
    //刷新
    beforeunloadFn(e) {
      console.log("这是刷新");
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
      this.currentPage = 1;
    },
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    // pdf加载时
    loadPdfHandler() {
      // this.currentPage = 1; // 加载的时候先加载第一页
    },
    // 放大
    scaleD() {
      this.scale += 5;
      // this.$refs.wrapper.$el.style.transform = "scale(" + this.scale + ")";
      this.$refs.all.style.width = parseInt(this.scale) + "%";
    },
    // 缩小
    scaleX() {
      if (this.scale <= 20) {
        return;
      }
      this.scale += -5;
      this.$refs.all.style.width = parseInt(this.scale) + "%";
      // this.$refs.wrapper.$el.style.transform = "scale(" + this.scale + ")";
    },
    // 全屏模式 将方法绑定(点击事件)到页面的元素上即可
    screenfull() {
      if (!screenfull.isEnabled) {
        // console.log('您的浏览器无法进入全屏模式')
        return false;
      }
      screenfull.toggle(this.$refs.all);
      this.fullscreen = true;
    },
    // Esc 全屏监测
    checkFull() {
      let isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
};
</script>
<style lang="stylus" scoped>
.ispdf {
  .title {
    height: 65px;
    border-bottom: 1px solid #eee;
    margin-left: 38px;
    margin-right: 39px;
    display: flex;
    position: relative;

    span {
      color: #333333;
      font-size: 18px;
      padding-top: 30px;
    }

    button {
      border: 0;
      outline: none;
      width: 99px;
      height: 30px;
      background-color: #ffffff;
      border: solid 1px #cecece;
      color: #ef9545;
      font-size: 14px;
      position: absolute;
      right: 17px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .content {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 50px;
    margin-left: 33px;
    margin-right: 33px;
    min-height: 500px;

    .bigbox {
      max-width: 1400px;
      max-height: 700px;
      overflow-y: auto;
      overflow-x: auto;
      margin: 0 auto;
      background-color: #f6f6f6;

      .pdfbox {
        padding: 0 0 rem(80);

        .head {
          height: 28px;
          line-height: 28px;
          display: flex;
          background: #ddd;
          min-width: 1400px;
          position: relative;

          .mod {
            display: flex;
            margin: 0 auto;
            line-height: 28px;

            .left {
              height: 28px;
              line-height: 28px;
              overflow: hidden;

              img {
                width: 34px;
                height: 20px;
                margin-top: -2px;
              }
            }

            .right {
              height: 28px;
              line-height: 28px;
              overflow: hidden;

              img {
                width: 34px;
                height: 20px;
                margin-top: -2px;
              }
            }

            span {
              padding-left: 5px;
              padding-right: 5px;
            }
          }

          ul {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 20px;
            display: flex;

            li {
              width: 30px;
              border-right: 1px solid #b3b3b3;
              text-align: center;

              img {
                width: 17px;
                height: 16px;
              }
            }

            li:last-child {
              border-right: 0;
            }
          }
        }

        .con {
          margin: 30px auto;
          background: #f6f6f6;
          width: 900px;

          canvas {
            height: 100% !important;
            width: 100%;
          }

          .annotationLayer {
            height: 100% !important;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
